import AuthContext from '@contexts/Auth'
import React, { useContext } from 'react'
import { LuArrowRight } from 'react-icons/lu'
import Team from '@resources/imgs/home/pro-seed-equipe.webp'
import './WelcomeHero.css'
import { Link } from 'react-router-dom'

const WelcomeHero: React.FC<any> = () => {
  const { user } = useContext(AuthContext)

  return (
    <section>
      <div className="hero-card overflow-hidden bg-white" style={{ borderRadius: 20 }}>
        <div className="row no-gutters align-items-stretch">
          <div
            className="col-12 col-md-7 d-flex flex-column justify-content-center p-4 p-md-5 hero-mobile-bg"
            style={{ position: 'relative', zIndex: 1 }}
          >
            <p className="homeuser-hero-kicker mb-2 font-weight-bold text-uppercase" style={{ color: '#FA5A84', letterSpacing: '0.08em', fontSize: '0.8125rem' }}>
              Bem-vinda de volta
            </p>

            <h1 className="homeuser-hero-title font-weight-bold text-dark mb-0">
              Olá, {user?.name?.split(' ')[0]}!
            </h1>

            <p
              className="homeuser-hero-lead mt-3 mb-0 text-muted"
              style={{ letterSpacing: '0.10em', lineHeight: 1.6 }}
            >
              Obrigada por escolher o Pro-Seed para realizar o seu sonho, com a maior segurança e variedade genética da América Latina.
            </p>

            <div className="d-flex flex-wrap align-items-center mt-5" style={{ gap: 12 }}>
              <Link to="/" target="_blank">
                <button
                  type="button"
                  className="btn rounded-pill px-4 py-2 d-inline-flex align-items-center"
                  style={{ backgroundColor: '#FA5A84', borderColor: '#FA5A84', color: '#FFFFFF' }}
                >
                Encontre seu doador ideal
                  <LuArrowRight className="ml-2" size={16} />
                </button>
              </Link>
            </div>
          </div>

          <div className="col-12 col-md-5 hero-image-col d-none d-md-block position-relative">
            <img
              className="w-100 h-100"
              style={{ objectFit: 'cover', minHeight: 260, display: 'block' }}
              src={Team}
              alt="Equipe médica Pro-Seed"
            />
            <div
              className="position-absolute h-100"
              style={{
                top: 0,
                left: 0,
                width: '45%',
                background: 'linear-gradient(to right, #ffffff, rgba(255,255,255,0))',
                pointerEvents: 'none',
              }}
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default WelcomeHero
